// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.linear-gauge-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 5px;
  margin-top: 5px;
  animation-name: toggleAnimation;
  animation-duration: 0.6s;
  animation-timing-function: ease-in-out;
}

@keyframes toggleAnimation {
  60% {
    opacity: 0.1;
  }
}

.linear-gauge {
  -webkit-appearance: none;
  width: 100%;
  height: 1px !important;
  background: var(--os-gauge-track-normal);
  box-shadow: 1px 1px 8px var(--os-gauge-track-shadow);
  position: relative;
  z-index: 2;
}

.linear-gauge-warning {
  -webkit-appearance: none;
  width: 100%;
  height: 1px;
  background: var(--os-gauge-warning-track);
  box-shadow: 1px 1px 8px var(--os-gauge-track-shadow);
  animation: linear-gauge-warning-ani 4s ease 2s infinite alternate; /* name, duration, timing-function, delay, iteration-count, direction */
  position: relative;
  z-index: 2;
}
@keyframes linear-gauge-warning-ani {
  0% {
    background: var(--os-gauge-warning-track);
    box-shadow: 1px 1px 8px var(--os-gauge-track-shadow);
  }
  20% {
    background: var(--os-gauge-warning-track-dim);
  }
  40% {
    background: var(--os-gauge-warning-track);
    box-shadow: 1px 1px 8px var(--os-gauge-track-shadow);
  }
  100% {
    background: var(--os-gauge-warning-track);
    box-shadow: 1px 1px 8px var(--os-gauge-track-shadow);
  }
}

.linear-gauge-alarm {
  -webkit-appearance: none;
  width: 100%;
  height: 1px !important;
  background: var(--os-gauge-alarm-track);
  box-shadow: 1px 1px 8px var(--os-gauge-track-shadow);
  animation: linear-gauge-alarm-ani 4s ease 2s infinite alternate;
  position: relative;
  z-index: 2;
}
@keyframes linear-gauge-alarm-ani {
  0% {
    background: var(--os-gauge-alarm-track);
    box-shadow: 1px 1px 8px var(--os-gauge-track-shadow);
  }
  20% {
    background: var(--os-gauge-alarm-track-dim);
  }
  40% {
    background: var(--os-gauge-alarm-track);
    box-shadow: 1px 1px 8px var(--os-gauge-track-shadow);
  }
  100% {
    background: var(--os-gauge-alarm-track);
    box-shadow: 1px 1px 8px var(--os-gauge-track-shadow);
  }
}

/* Linear gauges slider thumb styling
Optimal thumb, warning thumb, alarm thumb */
.linear-gauge::-webkit-slider-thumb {
  -webkit-appearance: none;
  /* appearance: none; */
  background: var(--os-gauge-thumb-normal);
  height: 8px;
  width: 8px;
  transform: rotate(45deg);
}
.linear-gauge-warning::-webkit-slider-thumb {
  -webkit-appearance: none;
  background: var(--os-gauge-thumb-warning);
  height: 8px;
  width: 8px;
  transform: rotate(45deg);
}
.linear-gauge-alarm::-webkit-slider-thumb {
  -webkit-appearance: none;
  background: var(--os-gauge-thumb-alarm);
  height: 8px;
  width: 8px;
  transform: rotate(45deg);
}
/* .linear-gauge::-moz-range-thumb {
  -webkit-appearance: none;
  appearance: none;
  background: var(--kontram-green);
  height: 9px;
  width: 9px;
  transform: rotate(45deg);
} */

/* Linear gauges TICKS! 
Optimal, Warning, Alarm */

.tick-optimal-value {
  background: var(--os-gauge-tick-optimal);
  height: 12px;
  width: 1px;
  z-index: 1;
}

.tick-warning-value {
  background: var(--os-gauge-tick-warning);
  height: 14px;
  width: 1px;
  z-index: 1;
}

.tick-warning-value-active {
  background: var(--os-gauge-tick-warning-active);
  height: 15px;
  width: 2px;
  z-index: 1;
}

.tick-alarm-value {
  background: var(--os-gauge-tick-alarm);
  height: 16px;
  width: 1px;
  z-index: 1;
}

.tick-alarm-value-active {
  background: var(--os-gauge-tick-alarm-active);
  height: 17px;
  width: 2px;
}

/* LINEAR GAUGE-FILL STYLING */

.linear-gauge-fill {
  -webkit-appearance: none;
  width: 100%;
  height: 7px !important;
  overflow: hidden !important;
  background: var(--os-gauge-track-normal);
  box-shadow: 1px 1px 8px var(--os-gauge-track-shadow);
}

.linear-gauge-fill-warning {
  -webkit-appearance: none;
  width: 100%;
  height: 7px !important;
  overflow: hidden !important;
  background: var(--os-gauge-track-normal);
  box-shadow: 1px 1px 8px var(--os-gauge-track-shadow);
  animation: linear-gauge-fill-warning-ani 4s ease 2s infinite alternate;
}
@keyframes linear-gauge-fill-warning-ani {
  0% {
    background: var(--os-gauge-track-normal);
    box-shadow: 1px 1px 8px var(--os-gauge-track-shadow);
  }
  20% {
    background: var(--os-gauge-fill-warning-dim);
  }
  40% {
    background: var(--os-gauge-track-normal);
    box-shadow: 1px 1px 8px var(--os-gauge-track-shadow);
  }
  100% {
    background: var(--os-gauge-track-normal);
    box-shadow: 1px 1px 8px var(--os-gauge-track-shadow);
  }
}

.linear-gauge-fill-alarm {
  -webkit-appearance: none;
  width: 100%;
  height: 7px !important;
  overflow: hidden !important;
  background: var(--os-gauge-track-normal);
  box-shadow: 1px 1px 8px var(--os-gauge-track-shadow);
  animation: linear-gauge-fill-alarm-ani 4s ease 2s infinite alternate;
}
@keyframes linear-gauge-fill-alarm-ani {
  0% {
    background: var(--os-gauge-track-normal);
    box-shadow: 1px 1px 8px var(--os-gauge-track-shadow);
  }
  20% {
    background: var(--os-gauge-fill-alarm-dim);
  }
  40% {
    background: var(--os-gauge-track-normal);
    box-shadow: 1px 1px 8px var(--os-gauge-track-shadow);
  }
  100% {
    background: var(--os-gauge-track-normal);
    box-shadow: 1px 1px 8px var(--os-gauge-track-shadow);
  }
}

.linear-gauge-fill::-webkit-slider-thumb {
  -webkit-appearance: none;
  background: var(--os-gauge-fill-thumb);
  /* background: var(--kontram-green); */
  height: 8px;
  width: 8px;
  transform: rotate(35deg);
  box-shadow: -500px 0px 0px 500px var(--os-gauge-fill-thumb);
  /* box-shadow: -500px 0px 0px 500px var(--kontram-green); */
}
.linear-gauge-fill-warning::-webkit-slider-thumb {
  -webkit-appearance: none;
  background: var(--os-gauge-thumb-warning);
  height: 8px;
  width: 8px;
  transform: rotate(35deg);
  box-shadow: -500px 0px 0px 500px var(--os-gauge-thumb-warning);
}
.linear-gauge-fill-alarm::-webkit-slider-thumb {
  -webkit-appearance: none;
  background: var(--os-gauge-thumb-alarm);
  height: 8px;
  width: 8px;
  transform: rotate(35deg);
  box-shadow: -500px 0px 0px 500px var(--os-gauge-thumb-alarm);
}
`, "",{"version":3,"sources":["webpack://./src/Dashboard/components/overview/devices/linearGauge/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,+BAA+B;EAC/B,wBAAwB;EACxB,sCAAsC;AACxC;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,sBAAsB;EACtB,wCAAwC;EACxC,oDAAoD;EACpD,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,WAAW;EACX,yCAAyC;EACzC,oDAAoD;EACpD,iEAAiE,EAAE,uEAAuE;EAC1I,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE;IACE,yCAAyC;IACzC,oDAAoD;EACtD;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,yCAAyC;IACzC,oDAAoD;EACtD;EACA;IACE,yCAAyC;IACzC,oDAAoD;EACtD;AACF;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,sBAAsB;EACtB,uCAAuC;EACvC,oDAAoD;EACpD,+DAA+D;EAC/D,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE;IACE,uCAAuC;IACvC,oDAAoD;EACtD;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,uCAAuC;IACvC,oDAAoD;EACtD;EACA;IACE,uCAAuC;IACvC,oDAAoD;EACtD;AACF;;AAEA;2CAC2C;AAC3C;EACE,wBAAwB;EACxB,sBAAsB;EACtB,wCAAwC;EACxC,WAAW;EACX,UAAU;EACV,wBAAwB;AAC1B;AACA;EACE,wBAAwB;EACxB,yCAAyC;EACzC,WAAW;EACX,UAAU;EACV,wBAAwB;AAC1B;AACA;EACE,wBAAwB;EACxB,uCAAuC;EACvC,WAAW;EACX,UAAU;EACV,wBAAwB;AAC1B;AACA;;;;;;;GAOG;;AAEH;yBACyB;;AAEzB;EACE,wCAAwC;EACxC,YAAY;EACZ,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,wCAAwC;EACxC,YAAY;EACZ,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,+CAA+C;EAC/C,YAAY;EACZ,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,6CAA6C;EAC7C,YAAY;EACZ,UAAU;AACZ;;AAEA,8BAA8B;;AAE9B;EACE,wBAAwB;EACxB,WAAW;EACX,sBAAsB;EACtB,2BAA2B;EAC3B,wCAAwC;EACxC,oDAAoD;AACtD;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,sBAAsB;EACtB,2BAA2B;EAC3B,wCAAwC;EACxC,oDAAoD;EACpD,sEAAsE;AACxE;AACA;EACE;IACE,wCAAwC;IACxC,oDAAoD;EACtD;EACA;IACE,4CAA4C;EAC9C;EACA;IACE,wCAAwC;IACxC,oDAAoD;EACtD;EACA;IACE,wCAAwC;IACxC,oDAAoD;EACtD;AACF;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,sBAAsB;EACtB,2BAA2B;EAC3B,wCAAwC;EACxC,oDAAoD;EACpD,oEAAoE;AACtE;AACA;EACE;IACE,wCAAwC;IACxC,oDAAoD;EACtD;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,wCAAwC;IACxC,oDAAoD;EACtD;EACA;IACE,wCAAwC;IACxC,oDAAoD;EACtD;AACF;;AAEA;EACE,wBAAwB;EACxB,sCAAsC;EACtC,sCAAsC;EACtC,WAAW;EACX,UAAU;EACV,wBAAwB;EACxB,2DAA2D;EAC3D,2DAA2D;AAC7D;AACA;EACE,wBAAwB;EACxB,yCAAyC;EACzC,WAAW;EACX,UAAU;EACV,wBAAwB;EACxB,8DAA8D;AAChE;AACA;EACE,wBAAwB;EACxB,uCAAuC;EACvC,WAAW;EACX,UAAU;EACV,wBAAwB;EACxB,4DAA4D;AAC9D","sourcesContent":[".linear-gauge-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 5px;\n  margin-top: 5px;\n  animation-name: toggleAnimation;\n  animation-duration: 0.6s;\n  animation-timing-function: ease-in-out;\n}\n\n@keyframes toggleAnimation {\n  60% {\n    opacity: 0.1;\n  }\n}\n\n.linear-gauge {\n  -webkit-appearance: none;\n  width: 100%;\n  height: 1px !important;\n  background: var(--os-gauge-track-normal);\n  box-shadow: 1px 1px 8px var(--os-gauge-track-shadow);\n  position: relative;\n  z-index: 2;\n}\n\n.linear-gauge-warning {\n  -webkit-appearance: none;\n  width: 100%;\n  height: 1px;\n  background: var(--os-gauge-warning-track);\n  box-shadow: 1px 1px 8px var(--os-gauge-track-shadow);\n  animation: linear-gauge-warning-ani 4s ease 2s infinite alternate; /* name, duration, timing-function, delay, iteration-count, direction */\n  position: relative;\n  z-index: 2;\n}\n@keyframes linear-gauge-warning-ani {\n  0% {\n    background: var(--os-gauge-warning-track);\n    box-shadow: 1px 1px 8px var(--os-gauge-track-shadow);\n  }\n  20% {\n    background: var(--os-gauge-warning-track-dim);\n  }\n  40% {\n    background: var(--os-gauge-warning-track);\n    box-shadow: 1px 1px 8px var(--os-gauge-track-shadow);\n  }\n  100% {\n    background: var(--os-gauge-warning-track);\n    box-shadow: 1px 1px 8px var(--os-gauge-track-shadow);\n  }\n}\n\n.linear-gauge-alarm {\n  -webkit-appearance: none;\n  width: 100%;\n  height: 1px !important;\n  background: var(--os-gauge-alarm-track);\n  box-shadow: 1px 1px 8px var(--os-gauge-track-shadow);\n  animation: linear-gauge-alarm-ani 4s ease 2s infinite alternate;\n  position: relative;\n  z-index: 2;\n}\n@keyframes linear-gauge-alarm-ani {\n  0% {\n    background: var(--os-gauge-alarm-track);\n    box-shadow: 1px 1px 8px var(--os-gauge-track-shadow);\n  }\n  20% {\n    background: var(--os-gauge-alarm-track-dim);\n  }\n  40% {\n    background: var(--os-gauge-alarm-track);\n    box-shadow: 1px 1px 8px var(--os-gauge-track-shadow);\n  }\n  100% {\n    background: var(--os-gauge-alarm-track);\n    box-shadow: 1px 1px 8px var(--os-gauge-track-shadow);\n  }\n}\n\n/* Linear gauges slider thumb styling\nOptimal thumb, warning thumb, alarm thumb */\n.linear-gauge::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  /* appearance: none; */\n  background: var(--os-gauge-thumb-normal);\n  height: 8px;\n  width: 8px;\n  transform: rotate(45deg);\n}\n.linear-gauge-warning::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  background: var(--os-gauge-thumb-warning);\n  height: 8px;\n  width: 8px;\n  transform: rotate(45deg);\n}\n.linear-gauge-alarm::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  background: var(--os-gauge-thumb-alarm);\n  height: 8px;\n  width: 8px;\n  transform: rotate(45deg);\n}\n/* .linear-gauge::-moz-range-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  background: var(--kontram-green);\n  height: 9px;\n  width: 9px;\n  transform: rotate(45deg);\n} */\n\n/* Linear gauges TICKS! \nOptimal, Warning, Alarm */\n\n.tick-optimal-value {\n  background: var(--os-gauge-tick-optimal);\n  height: 12px;\n  width: 1px;\n  z-index: 1;\n}\n\n.tick-warning-value {\n  background: var(--os-gauge-tick-warning);\n  height: 14px;\n  width: 1px;\n  z-index: 1;\n}\n\n.tick-warning-value-active {\n  background: var(--os-gauge-tick-warning-active);\n  height: 15px;\n  width: 2px;\n  z-index: 1;\n}\n\n.tick-alarm-value {\n  background: var(--os-gauge-tick-alarm);\n  height: 16px;\n  width: 1px;\n  z-index: 1;\n}\n\n.tick-alarm-value-active {\n  background: var(--os-gauge-tick-alarm-active);\n  height: 17px;\n  width: 2px;\n}\n\n/* LINEAR GAUGE-FILL STYLING */\n\n.linear-gauge-fill {\n  -webkit-appearance: none;\n  width: 100%;\n  height: 7px !important;\n  overflow: hidden !important;\n  background: var(--os-gauge-track-normal);\n  box-shadow: 1px 1px 8px var(--os-gauge-track-shadow);\n}\n\n.linear-gauge-fill-warning {\n  -webkit-appearance: none;\n  width: 100%;\n  height: 7px !important;\n  overflow: hidden !important;\n  background: var(--os-gauge-track-normal);\n  box-shadow: 1px 1px 8px var(--os-gauge-track-shadow);\n  animation: linear-gauge-fill-warning-ani 4s ease 2s infinite alternate;\n}\n@keyframes linear-gauge-fill-warning-ani {\n  0% {\n    background: var(--os-gauge-track-normal);\n    box-shadow: 1px 1px 8px var(--os-gauge-track-shadow);\n  }\n  20% {\n    background: var(--os-gauge-fill-warning-dim);\n  }\n  40% {\n    background: var(--os-gauge-track-normal);\n    box-shadow: 1px 1px 8px var(--os-gauge-track-shadow);\n  }\n  100% {\n    background: var(--os-gauge-track-normal);\n    box-shadow: 1px 1px 8px var(--os-gauge-track-shadow);\n  }\n}\n\n.linear-gauge-fill-alarm {\n  -webkit-appearance: none;\n  width: 100%;\n  height: 7px !important;\n  overflow: hidden !important;\n  background: var(--os-gauge-track-normal);\n  box-shadow: 1px 1px 8px var(--os-gauge-track-shadow);\n  animation: linear-gauge-fill-alarm-ani 4s ease 2s infinite alternate;\n}\n@keyframes linear-gauge-fill-alarm-ani {\n  0% {\n    background: var(--os-gauge-track-normal);\n    box-shadow: 1px 1px 8px var(--os-gauge-track-shadow);\n  }\n  20% {\n    background: var(--os-gauge-fill-alarm-dim);\n  }\n  40% {\n    background: var(--os-gauge-track-normal);\n    box-shadow: 1px 1px 8px var(--os-gauge-track-shadow);\n  }\n  100% {\n    background: var(--os-gauge-track-normal);\n    box-shadow: 1px 1px 8px var(--os-gauge-track-shadow);\n  }\n}\n\n.linear-gauge-fill::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  background: var(--os-gauge-fill-thumb);\n  /* background: var(--kontram-green); */\n  height: 8px;\n  width: 8px;\n  transform: rotate(35deg);\n  box-shadow: -500px 0px 0px 500px var(--os-gauge-fill-thumb);\n  /* box-shadow: -500px 0px 0px 500px var(--kontram-green); */\n}\n.linear-gauge-fill-warning::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  background: var(--os-gauge-thumb-warning);\n  height: 8px;\n  width: 8px;\n  transform: rotate(35deg);\n  box-shadow: -500px 0px 0px 500px var(--os-gauge-thumb-warning);\n}\n.linear-gauge-fill-alarm::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  background: var(--os-gauge-thumb-alarm);\n  height: 8px;\n  width: 8px;\n  transform: rotate(35deg);\n  box-shadow: -500px 0px 0px 500px var(--os-gauge-thumb-alarm);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
